import React from 'react';
import { Link } from 'react-router-dom';

//import logos (light + dark theme)
import logoAgerouteLight from "../assets/images/logo-ageroute-light.png";
import logoAgerouteDark from "../assets/images/logo-ageroute-dark.png";

//import Components
import LanguageDropdown from '../Components/Common/LanguageDropdown';
import FullScreenDropdown from '../Components/Common/FullScreenDropdown';
import NotificationDropdown from '../Components/Common/NotificationDropdown';
import ProfileDropdown from '../Components/Common/ProfileDropdown';
import LightDark from '../Components/Common/LightDark';

import { useLayoutStore } from "../stores/useLayoutStore";

const Header = ({ onChangeLayoutMode, layoutModeType, headerClass }: any) => {
    const sidebarVisibilitytype = useLayoutStore((s) => s.sidebarVisibilitytype);
    const changeSidebarVisibility = useLayoutStore((s) => s.changeSidebarVisibility);

    const toogleMenuBtn = () => {
        var windowSize = document.documentElement.clientWidth;
        changeSidebarVisibility("show");

        let hamburgerIcon: any = document.querySelector(".hamburger-icon")

        if (windowSize > 767)
            hamburgerIcon.classList.toggle('open');

        //For collapse horizontal menu
        if (document.documentElement.getAttribute('data-layout') === "horizontal") {
            document.body.classList.contains("menu") ? document.body.classList.remove("menu") : document.body.classList.add("menu");
        }

        //For collapse vertical and semibox menu
        if (sidebarVisibilitytype === "show" && (document.documentElement.getAttribute('data-layout') === "vertical" || document.documentElement.getAttribute('data-layout') === "semibox")) {
            if (windowSize < 1025 && windowSize > 767) {
                document.body.classList.remove('vertical-sidebar-enable');
                (document.documentElement.getAttribute('data-sidebar-size') === 'sm') ? document.documentElement.setAttribute('data-sidebar-size', '') : document.documentElement.setAttribute('data-sidebar-size', 'sm');
            } else if (windowSize > 1025) {
                document.body.classList.remove('vertical-sidebar-enable');
                (document.documentElement.getAttribute('data-sidebar-size') === 'lg') ? document.documentElement.setAttribute('data-sidebar-size', 'sm') : document.documentElement.setAttribute('data-sidebar-size', 'lg');
            } else if (windowSize <= 767) {
                document.body.classList.add('vertical-sidebar-enable');
                document.documentElement.setAttribute('data-sidebar-size', 'lg');
            }
        }


        //Two column menu
        if (document.documentElement.getAttribute('data-layout') === "twocolumn") {
            document.body.classList.contains('twocolumn-panel') ? document.body.classList.remove('twocolumn-panel') : document.body.classList.add('twocolumn-panel');
        }
    };

    return (
        <React.Fragment>
            <header id="page-topbar" className={headerClass}>
                <div className="layout-width">
                    <div className="navbar-header">
                        <div className="d-flex">

                            <div className="navbar-brand-box horizontal-logo">
                                <Link to="/" className="logo">
                                    <span className="logo-sm position-relative d-inline-block">
                                        <img src={logoAgerouteLight} alt="AGEROUTE" height="32" className="logo-img-light" />
                                        <img src={logoAgerouteDark} alt="AGEROUTE" height="32" className="logo-img-dark position-absolute top-0 start-0" />
                                    </span>
                                    <span className="logo-lg position-relative d-inline-block">
                                        <img src={logoAgerouteLight} alt="AGEROUTE" height="40" className="logo-img-light" />
                                        <img src={logoAgerouteDark} alt="AGEROUTE" height="40" className="logo-img-dark position-absolute top-0 start-0" />
                                    </span>
                                </Link>
                            </div>

                            <button
                                onClick={toogleMenuBtn}
                                type="button"
                                className="btn btn-sm px-3 fs-16 header-item vertical-menu-btn topnav-hamburger"
                                id="topnav-hamburger-icon">
                                <span className="hamburger-icon">
                                    <span></span>
                                    <span></span>
                                    <span></span>
                                </span>
                            </button>
                        </div>

                        <div className="d-flex align-items-center">
                            <LanguageDropdown />
                            <FullScreenDropdown />
                            {/* Dark/Light Mode set */}
                            <LightDark
                                layoutMode={layoutModeType}
                                onChangeLayoutMode={onChangeLayoutMode}
                            />

                            {/* NotificationDropdown */}
                            <NotificationDropdown />

                            {/* ProfileDropdown */}
                            <ProfileDropdown />
                        </div>
                    </div>
                </div>
            </header>
        </React.Fragment>
    );
};

export default Header;